const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};


export const SERVICE_ALL_FIELDS = [
    {
      id: "title",
      label: "Service Title",
      type: "text",
      isRequired: true,
      md:12,
    },
  {
    id: "date",
    label: "Service Date",
    type: "date",
    isRequired: true,
    md:5,
  },
   {
    id: "cost",
    label: "Cost",
    placeholder: "Cost",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 5,
  },
  {
    id: "is_paid",
    label: "\u00A0",
    checkLabel: "Paid",
    placeHolder: "Select Paid Status",
    type: "checkbox",
    md: 2,
  }
];